export { default } from './store/index'
